import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  const [userType, setUserType] = useState<'teacher' | 'student' | null>(null);

  return (
    <div className="app-container">
      <header className="header">
        <div className="header-content">
          <h1 className="logo">Quiz Autonome et Interactive</h1>
          <p>Application de quiz autonome et interactive</p>
        </div>
      </header>

      <main className="main-content">
        <div className="text-center mb-4">
          <h2>Bienvenue sur Quiz Autonome et Interactive</h2>
          <p className="mb-4">
            Créez des sessions interactives et engagez vos étudiants avec des questions en temps réel.
          </p>
        </div>

        {!userType ? (
          <div className="grid grid-2">
            <div className="card text-center">
              <div className="card-header">
                <h3 className="card-title">👨‍🏫 Enseignant</h3>
              </div>
              <div className="card-content">
                <p>
                  Créez des sessions, posez des questions et collectez les réponses de vos étudiants en temps réel.
                </p>
                <ul className="text-left mt-3">
                  <li>✅ Créer des sessions interactives</li>
                  <li>✅ Poser des questions QCM et ouvertes</li>
                  <li>✅ Voir les réponses en temps réel</li>
                  <li>✅ Exporter les résultats</li>
                </ul>
              </div>
              <div className="card-actions">
                <Link 
                  to="/teacher/login"
                  className="btn btn-primary"
                >
                  Je suis enseignant
                </Link>
              </div>
            </div>

            <div className="card text-center">
              <div className="card-header">
                <h3 className="card-title">🎓 Étudiant</h3>
              </div>
              <div className="card-content">
                <p>
                  Rejoignez une session avec un code et répondez aux questions de votre enseignant.
                </p>
                <ul className="text-left mt-3">
                  <li>✅ Rejoindre avec un code session</li>
                  <li>✅ Répondre aux questions</li>
                  <li>✅ Voir les résultats</li>
                  <li>✅ Interface simple et intuitive</li>
                </ul>
              </div>
              <div className="card-actions">
                <button 
                  className="btn btn-secondary"
                  onClick={() => setUserType('student')}
                >
                  Je suis étudiant
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="card text-center fade-in">
            <div className="card-header">
              <h3 className="card-title">
                {userType === 'teacher' ? '👨‍🏫 Espace Enseignant' : '🎓 Espace Étudiant'}
              </h3>
            </div>
            <div className="card-content">
              {userType === 'teacher' ? (
                <div>
                  <p className="mb-3">
                    Gérez vos sessions d'enseignement interactif
                  </p>
                  <div className="flex justify-center gap-2">
                    <Link to="/teacher/dashboard" className="btn btn-primary">
                      Tableau de bord
                    </Link>
                    <Link to="/teacher/sessions/new" className="btn btn-outline">
                      Nouvelle session
                    </Link>
                  </div>
                </div>
              ) : (
                <div>
                  <p className="mb-3">
                    Rejoignez une session avec le code fourni par votre enseignant
                  </p>
                  <Link to="/student/join" className="btn btn-secondary">
                    Rejoindre une session
                  </Link>
                </div>
              )}
            </div>
            <div className="card-actions">
              <button 
                className="btn btn-outline btn-sm"
                onClick={() => setUserType(null)}
              >
                ← Retour
              </button>
            </div>
          </div>
        )}

        <div className="card mt-4">
          <div className="card-header">
            <h3 className="card-title">🚀 Fonctionnalités</h3>
          </div>
          <div className="card-content">
            <div className="grid grid-3">
              <div className="text-center">
                <h4>⚡ Temps réel</h4>
                <p>Synchronisation instantanée des réponses et des questions</p>
              </div>
              <div className="text-center">
                <h4>📊 Statistiques</h4>
                <p>Visualisation des résultats et analyses des réponses</p>
              </div>
              <div className="text-center">
                <h4>📱 Responsive</h4>
                <p>Fonctionne sur tous les appareils (mobile, tablette, ordinateur)</p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="card mt-4">
          <div className="card-header">
            <h3 className="card-title">🔧 Outils de développement</h3>
          </div>
          <div className="card-content">
            <div className="flex justify-center gap-2">
              <Link to="/test" className="btn btn-outline">
                🧪 Test de connexion
              </Link>
            </div>
            <p className="text-center mt-2">
              <small>Vérifier que le frontend et le backend communiquent correctement</small>
            </p>
          </div>
        </div> */}
      </main>
    </div>
  );
};

export default Home;
